import { collection, limit, onSnapshot, orderBy, query } from 'firebase/firestore';
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { db } from '../../firebase';
import Pagecontainer from '../Pagecontainer'

const News = (props) => {
    const [news, setNews] = React.useState([]);
    const [newsId, setNewsId] = React.useState([]);

    useEffect(() => {
        try {
            const q = query(collection(db, "news"), orderBy("timestamp", "desc"), limit(6));
            const unsubscribe = onSnapshot(q, (querySnapshot) => {
                setNewsId(querySnapshot.docs.map(doc => doc.id));
                setNews(querySnapshot.docs.map(doc => doc.data()));
            }
                , [])
        } catch (e) {
            // console.log(e)
        }
    }, []);

    return (
        <>
            <Pagecontainer>
                {
                    props.title === true &&
                    <div className='flex flex-col items-center justify-center mt-20 mb-12'>
                        <h3 className='text-primary font-sans text-2xl md:text-3xl font-bold uppercase tracking-wide'>
                            News &amp; Events
                        </h3>
                        <div className='w-[30px] bg-primary h-[4px] my-2' />
                    </div>
                }
                <div className='pb-10'>
                    {news.length > 0 ? (
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 px-5">
                            {news.map((newsItem, index) => (
                                <NewsCard
                                    key={newsId[index]}
                                    id={newsId[index]}
                                    title={newsItem.title}
                                    content={newsItem.content}
                                    image={newsItem.image}
                                    date={newsItem.date}
                                />
                            ))}
                        </div>
                    ) : (
                        <div className='flex flex-col items-center justify-center py-20'>
                            <div className='text-gray-400 mb-4'>
                                <i className="bi bi-newspaper text-6xl"></i>
                            </div>
                            <h3 className='text-gray-600 text-lg font-medium'>
                                No news found.
                            </h3>
                        </div>
                    )}
                    {news.length > 0 && (
                        <div className='flex justify-center mt-10'>
                            <Link
                                to="/news"
                                className='group inline-flex items-center gap-2 bg-primary hover:bg-primary-d text-white px-6 py-3 font-medium uppercase tracking-wide transition-all duration-300'
                            >
                                <span>View All News</span>
                                <i className="bi bi-arrow-right group-hover:translate-x-1 transition-transform duration-300"></i>
                            </Link>
                        </div>
                    )}
                </div>
            </Pagecontainer>
        </>
    )
}

const NewsCard = ({ id, title, content, image, date }) => {
    const truncatedTitle = title && title.length > 60 ? title.substring(0, 60) + '...' : title;
    const truncatedContent = content && content.length > 120 ? content.substring(0, 120) + '...' : content;

    return (
        <Link
            to={`/news/${id}`}
            className="group block h-full"
        >
            <div className="relative h-full bg-white border overflow-hidden flex flex-col">
                {/* Image Container */}
                <div className="relative h-48 md:h-56 overflow-hidden bg-gray-100">
                    <img
                        src={image}
                        alt={title || 'News image'}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                    {/* Gradient Overlay */}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                    {/* Date Badge */}
                    {date && (
                        <div className="absolute top-4 left-4 bg-primary text-white px-3 py-1 text-xs font-medium">
                            {date}
                        </div>
                    )}
                </div>

                {/* Content Container */}
                <div className="flex-1 flex flex-col p-5 md:p-6">
                    <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-3 group-hover:text-primary transition-colors duration-300 font-kalimati">
                        {truncatedTitle}
                    </h3>
                    <p className="text-gray-600 text-sm md:text-base mb-4 flex-1 overflow-hidden font-vesper">
                        {truncatedContent}
                    </p>

                    {/* Read More Link */}
                    <div className="flex items-center gap-2 text-primary font-medium text-sm mt-auto pt-3 border-t border-gray-100 group-hover:border-primary/30 transition-colors duration-300">
                        <span>Read More</span>
                        <i className="bi bi-arrow-right-circle group-hover:translate-x-1 transition-transform duration-300"></i>
                    </div>
                </div>
            </div>
        </Link>
    )
}

export default News